/**************************************************
 * Nombre:       Seccion_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     12 Hr
 **************************************************/
import {Button, Grid, useMediaQuery} from "@mui/material";
import {useObtenerColleccionTabla} from "../../Servicios/BD/useObtenerColleccionTabla";
import {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_dialogos/Hooks/useDialogo";
import TituloNotificaciones from "../../Modulo_dashboard/ComponentesSecundarios/TituloNotificaciones";
import TablaBasica from "../../Modulo_tablas/Componentes/TablaBasica";
import {theme} from "../../Tema";
import Dialogo_Potenciales from "../Dialogos/Dialogo_Potenciales";
import {ESTADOSPOTENCIALES} from "../../Constantes";
import {contarPropiedad} from "../../Servicios/BD/Contadores/contarPropiedad";
import Indicadores from "../../Modulo_Graficas/Componentes/Indicadores/Indicadores";
import {obtenerMesYearAnterior} from "../../Modulo_Graficas/Utilidades/obtenerMesYearAnterior";
import {adaptador_indicador} from "../../Modulo_Graficas/Adaptadores/adaptador_indicador";
import {contarPropiedadMes} from "../../Servicios/BD/Contadores/contarPropiedadMes";
import {CloudDownload, Edit, ManageSearch} from "@mui/icons-material";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {LoadingButton} from "@mui/lab";
import {contarColeccion} from "../../Servicios/BD/Contadores/contarColeccion";
import {idID} from "@mui/material/locale";

const Seccion_Potenciales = () => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const [numPotencialesNuevas, setNumPotencialesNuevas] = useState(0)
    const [numPotenciales, setNumPotenciales] = useState(0)
    const [recargar, setRecargar] = useState(false)
    const {props, cargarNuevamente} = useObtenerColleccionTabla({
        coleccion: 'potenciales',
        filtroInicial: 'fecha',
        dirInicial: 'desc'
    })
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Potenciales,
        realizado: () => setRecargar(!recargar),
        titulo: 'Detalle de potencial'
    })
    const [cargando, setCargando] = useState(false)


    const manejardorClicks = (row, id) => {

        switch (id) {
            case 'ver' :
                abrir(row)
                break
        }

    }

    const exportarDatos = () => {
        setCargando(true)
        obtenerCol('potenciales').then((dox) => {
            if (dox.res) {
                let arr = dox.data
                const worksheet = XLSX.utils.json_to_sheet(arr);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                // Buffer to store the generated Excel file
                const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
                const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});

                saveAs(blob, "Potenciales.xlsx");
            }
            setCargando(false)
        })
    }


    useEffect(() => {

        contarPropiedad({coleccion: 'potenciales', propiedad: 'estado', valor: 'Nueva'}).then((dox) => {
            if (dox.res) {
                setNumPotencialesNuevas(dox.data)
            }
        })

        contarColeccion({coleccion: 'potenciales'}).then((dox) => {
            if (dox.res) {
                setNumPotenciales(dox.data)
            }
        })

        cargarNuevamente()

    }, [recargar]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
        >

            <Dialogo/>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start'}}>
                <TituloNotificaciones titulo={'Potenciales'} textoComplementario={'socias nuevas'}
                                      textoResaltado={`${numPotencialesNuevas} Pontenciales`}/>
            </Grid>


            <Grid item container lg={12} sm={12} xs={12}
                  sx={{justifyContent: 'flex-end', marginTop: 2, marginBottom: -3}}>
                <LoadingButton variant={'contained'}
                               loading={cargando}
                               onClick={() => exportarDatos()}
                               endIcon={<CloudDownload/>}>Exportar datos</LoadingButton>
            </Grid>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start', marginTop: 5}}>
                <TablaBasica
                    filtros={filtros}
                    datosCabecera={sCell ? datosCabeceraCell : datosCabecera}
                    {...props}
                    estados={ESTADOSPOTENCIALES}
                    click={manejardorClicks}
                    botonesTabla={botonesTabla}
                    numeroFilas={numPotenciales}
                />
            </Grid>


        </Grid>
    )

}
export default Seccion_Potenciales

const filtros = [
    {
        nombre: 'Nombre',
        propiedad: 'nombre',

    },
    {
        nombre: 'Mas Reciente',
        propiedad: 'fecha',
        direccion: 'desc'

    }
]

const datosCabecera = [
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedad: 'fecha',
        tipo: 'fecha'

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',

    },
    {
        nombre: 'Pais',
        direccion: 'right',
        propiedad: 'pais',

    },
    {
        nombre: 'Ciudad',
        direccion: 'right',
        propiedad: 'ciudad',

    }

]


const datosCabeceraCell = [
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedad: 'fecha',
        tipo: 'fecha'

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',

    }
]

const botonesTabla = [
    {
        nombre: 'Ver Detalle',
        icono: ManageSearch,
        id: 'ver'
    },

]



